namespace GeniuzPOS.Purchase {
    export namespace PoCreditNoteService {
        export const baseUrl = 'Purchase/PoCreditNote';

        export declare function Create(request: Serenity.SaveRequest<PoCreditNoteRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PoCreditNoteRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PoCreditNoteRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PoCreditNoteRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetNextNumber(request: GetNextNumberRequest, onSuccess?: (response: GetNextNumberResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function UpdateCancelAndUseFg(request: UpdateCancelAndUseFgRequest, onSuccess?: (response: Serenity.ServiceResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Purchase/PoCreditNote/Create",
            Update = "Purchase/PoCreditNote/Update",
            Delete = "Purchase/PoCreditNote/Delete",
            Retrieve = "Purchase/PoCreditNote/Retrieve",
            List = "Purchase/PoCreditNote/List",
            GetNextNumber = "Purchase/PoCreditNote/GetNextNumber",
            UpdateCancelAndUseFg = "Purchase/PoCreditNote/UpdateCancelAndUseFg"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'GetNextNumber', 
            'UpdateCancelAndUseFg'
        ].forEach(x => {
            (<any>PoCreditNoteService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
